export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/point.js
// module id = 233
// module chunks = 0